// @ts-nocheck
/// <reference path="../../../../../rcwebmodels/geofencemodel.cs.d.ts" />
import * as React from 'react';
//import Bing from '../../actions/ReeferMap.js';
//import * as ReeferMapjs from '../../actions/ReeferMap.js';
//var Bing = ReeferMapjs.default;
import ReeferCallout from '../../actions/ReeferCallout';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import $ from 'jquery';
import UserRights from '../../actions/UserRights';

import fenceGrey from '../../images/fenceGrey.png';
import fenceDark from '../../images/fenceDark.png';
import fenceWhite from '../../images/fenceWhite.png';

var Config: any = require('../../Config.json');
export interface ReeferMapState {
    modelTitleReport: string;
    popUpHtmlReport: any;
    PTReport: string;
    ReportReeferId: string;
    buttonState: boolean;
    fenceImage: boolean;
    IsLocationEstimated: boolean;
    geoZonesEnabled: boolean;
    geoZonesImage: boolean;
}

var self;
var IsTriggered = false;
var fencesLoaded;

export class ReeferMap extends React.Component<any, ReeferMapState> {
    constructor(props: any) {
        super(props);
        this.state = {
            modelTitleReport: '', popUpHtmlReport: '', PTReport: '', ReportReeferId: '',
            buttonState: true, fenceImage: true, IsLocationEstimated: false, geoZonesEnabled: true, geoZonesImage: true
        };
        self = this;
        IsTriggered = false;
        fencesLoaded = false;
    }

    componentWillReceiveProps(nextprops: any) {
        const allAssetStatusData: any = this.props.allAssetStatusData;
        if (nextprops.allAssetStatusData != undefined && nextprops.allAssetStatusData != null) {
            if ((nextprops.allAssetStatusData.Dry != undefined && nextprops.allAssetStatusData.Dry.length > 0) || (nextprops.allAssetStatusData.Genset != undefined && nextprops.allAssetStatusData.Genset.length > 0) ||
                (nextprops.allAssetStatusData.Chassis != undefined && nextprops.allAssetStatusData.Chassis.length > 0) || (nextprops.allAssetStatusData.Reefers != undefined && nextprops.allAssetStatusData.Reefers.length > 0)) {
                if (nextprops.allAssetStatusData !== allAssetStatusData)
                    ReeferCallout.BindClusterMapAllAssetsPushpins(nextprops.allAssetStatusData, 'All Assets', this.props.propsReeferFormatterData, this.props.isFenceAssets);
            }
            else {
                if (nextprops.allAssetStatusData.length > 0 && !nextprops.eventsRefresh) {
                    if (nextprops.allAssetStatusData !== allAssetStatusData)
                        ReeferCallout.BindClusterMapPushpins(nextprops.allAssetStatusData, nextprops.gridType, this.props.propsReeferFormatterData);
                }
            }
        }
    }

   
    public render() {
        //if (!this.state.buttonState && !$("#DrawPolygonMode").hasClass("active") && !$("#EditPolygonMode").hasClass("active") && !$("#DeletePolygonMode").hasClass("active"))
        //    this.loadCustomerGeofences(false);
        return <div>
            <div id="drawingManager">
                <div id="DrawingModes" className="btn-group btn-group-dsd geofence-controls" role="group" data-bs-toggle="buttons">
                     {/*<input type="radio" className='btn-check' name="options" autocomplete="off" />*/}
                    <label className="btn btn-outline-secondary" id="DrawPolygonMode" title="Add a geofence" onClick={this.drawingModePolygon.bind(this)} >    <span className="fas fa-draw-polygon" ></span>  </label>
                 
                     {/*<input type="radio" className='btn-check' name="options" autocomplete="off" />*/}
                    <label className="btn btn-outline-secondary" id="EditPolygonMode" title="Edit an existing geofence" onClick={this.drawingModeEdit.bind(this)} >   <span className="fas fa-pencil"></span>  </label>
                  
                     {/*<input type="radio" className='btn-check' name="options" autocomplete="off" />*/}
                    <label className="btn btn-outline-secondary" id="DeletePolygonMode" title="Delete an existing geofence" onClick={this.drawingModeDelete.bind(this)}>  <span className="fa-regular fa-eraser"></span>  </label>
                
                   
                </div>
                <div className='map-autosuggest' id="searchBoxContainer"> <input type="text" id="txtSearchBox" className="form-control" placeholder="Address, Business, Place, Zip code, etc." /></div>
                <div id="AddGeofenceMode" className='alert alert-warning geofenceMap-info'> 
                    <ul>
                        <li>Left click on map to add points (up to 12) for a new geofence polygon</li>
                        <li>To stop drawing, double-click when creating the last point</li>
                    </ul>  
                </div>
                <div id="EditGeofenceMode" className='alert alert-warning geofenceMap-info'>
                    <ul>
                        <li>Click on a geofence to edit</li>
                        <li>When done editing, click on the “edit” button</li>
                        <li>Right click on any geofence point to remove (undo)</li>
                    </ul>
                </div>
                <div id="DeleteGeofenceMode" className='alert alert-warning geofenceMap-info'>
                    <ul>
                        <li>Click on one or more geofences to delete</li>
                        <li>When done deleting, click on the “delete” button</li>
                    </ul>
                </div>
            </div>
            <div id='reeferMap' className='ReeferMapCallout'> </div>
            {this.state.IsLocationEstimated == true ? <div id='divLocationEstm' className='ReeferMapLegend'>Location estimated</div> : ''}
            <div id='mapFences' className='map-Geofence'>
                {
                    this.state.buttonState == true ? <img title='Show Geofences' className='fenceimg' src={this.state.fenceImage == true ? fenceGrey : fenceWhite} alt='Fence' onClick={this.showDrawingManagerTools.bind(this)} />
                        : <img className='fenceimg' title='Hide Geofences' src={this.state.fenceImage == true ? fenceDark : fenceWhite} alt='Fence' onClick={this.closeDrawingManagerTools.bind(this)} />
                }
            </div>
            <div id='geoZones' className='map-geoZones'>
                {
                    this.state.geoZonesEnabled == true ? <span title='Show Accuracy' class={this.state.geoZonesImage == true ? "fa-regular fa-bullseye-arrow target-icon opacity-25" : "fa-regular fa-bullseye-arrow target-icon text-white"} onClick={this.showGeoZonesLayer.bind(this)}></span>
                        : <span title='Hide Accuracy' class={this.state.geoZonesImage == true ? "fa-regular fa-bullseye-arrow target-icon" : "fa-regular fa-bullseye-arrow target-icon text-white"} onClick={this.hideGeoZonesLayer.bind(this)}></span>
                }
            </div>
            {this.state.buttonState == false ?
                <div className='ReeferMapLegend'>
                    <div>      ------------------ Server Geofence  </div>
                    <div className='flex-container'> <div className='borderFence'></div> <div>Device Geofence</div> </div>
                </div>:<div></div>
                }
        </div>;
    }

    static UpdateFenceImage(src:any) {
        if (src == "A")
            self.setState({ fenceImage: false, geoZonesImage: false });
        else
            self.setState({ fenceImage: true, geoZonesImage: true });
    }

    static UpdateIsLocationEstimated(IsLocEstEnabled: any) {
        if (self != null && self != undefined) {
            if (IsLocEstEnabled == true)
                self.setState({ IsLocationEstimated: true });
            else
                self.setState({ IsLocationEstimated: false });

            if(self.state.buttonState == false) {            
                if ($("#divLocationEstm").hasClass("ReeferMapLegend")) $('#divLocationEstm').removeClass('ReeferMapLegend');
                $('#divLocationEstm').addClass('ReeferMapEstimated');
             }
            else  {
                if ($("#divLocationEstm").hasClass("ReeferMapEstimated")) $('#divLocationEstm').removeClass('ReeferMapEstimated');
                $('#divLocationEstm').addClass('ReeferMapLegend');
             }
        }
    }

    public componentDidMount() {
        ReeferCallout.InitializeMap("reeferMap");     
        $('#geoZones').hide();  
        $("#DrawingModes").hide();
        $("#AddGeofenceMode").hide();
        $("#EditGeofenceMode").hide();
        $("#DeleteGeofenceMode").hide();
        //$("#reeferMap .drawingBar ul.actions").find("li:eq(3)").prop('title', 'Add a geofence');
        //$("#reeferMap .drawingBar ul.actions").find("li:eq(4)").prop('title', 'Edit an existing geofence');
        //$("#reeferMap .drawingBar ul.actions").find("li:eq(5)").prop('title', 'Delete an existing geofence');

        setTimeout(() => {
            self.bindMapPushpins()
        }, 1000);
    }

    bindMapPushpins() {
        var allAssetStatusData: any = this.props.allAssetStatusData;
        if (allAssetStatusData != undefined && allAssetStatusData != null) {
            if ((allAssetStatusData.Dry != undefined && allAssetStatusData.Dry.length > 0) || (allAssetStatusData.Genset != undefined && allAssetStatusData.Genset.length > 0) ||
                (allAssetStatusData.Chassis != undefined && allAssetStatusData.Chassis.length > 0) || (allAssetStatusData.Reefers != undefined && allAssetStatusData.Reefers.length > 0)) {
                ReeferCallout.BindClusterMapAllAssetsPushpins(allAssetStatusData, 'All Assets', this.props.propsReeferFormatterData, this.props.isFenceAssets);
            }
            else {
                if (allAssetStatusData.length > 0) {
                    ReeferCallout.BindClusterMapPushpins(allAssetStatusData, this.props.gridType, this.props.propsReeferFormatterData);
                }
            }
        }
    }

    static bindGeofencePopupDashboard(currentMode: string, coordinates: any, currentFence: any, GeofencesData: any[]) {
        $("#globalLoader").show();
        IsTriggered = false;
        var latlonArray = [];
        if (coordinates.length > 0) {
            $.each(coordinates, function (index, value) {
                if ((index === (coordinates.length - 1)) || !(latlonArray.indexOf(value.latitude.toFixed(10) + ',' + value.longitude.toFixed(10)) > -1))
                    latlonArray.push(value.latitude.toFixed(10) + ',' + value.longitude.toFixed(10));
            });
        }
        var inputParams: server.GeofenceParams = { FenceTypeCd: '', FenceId: '', FenceName: '', Address: '', Coordinates: [], ActionTypeCd: '', GeofenceCustomerID: '' };
        inputParams.Coordinates = latlonArray;
        inputParams.FenceTypeCd = self.state.fenceTypeCd;
        if (currentFence != null && currentMode == 'edit')
            inputParams.GeofenceCustomerID = currentFence.GeofenceCustomerID;
        var geofenceParams = JSON.stringify(inputParams);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeofenceIntersect', { method: 'POST', body: geofenceParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GetGeofenceCoordinates[]>)
            .then(data => {
                if (data.length > 0) {
                    var intersectFences = '';
                    data.forEach(function (fence) {
                        var GeofenceCatogery = "";
                        if (fence.GeofenceCategoryCd == 'D') GeofenceCatogery = "Device Geofence";
                        if (fence.GeofenceCategoryCd == 'B') GeofenceCatogery = "Server Geofence";
                        if (fence.GeofenceCategoryCd == 'R') GeofenceCatogery = "Region Geofence";                        
                        intersectFences = intersectFences + "<div class='flex-container'><div>Fence ID: </div><div class='trunc fw-semibold ms-1' title='" + fence.Tag + "'>" + fence.Tag + "</div>,<div class='ms-2'>Fence Name: </div><div class='trunc fw-semibold ms-1' title='" + fence.Name + "'>" + fence.Name + "</div>,<div class='ms-2'>Geofence Category: </div><div class='fw-semibold ms-1'>" + GeofenceCatogery + "</div></div>";
                        //intersectFences = intersectFences + "<div class='flex-container'> <div>Fence ID: " + fence.Tag + ",</div><div class='ms-2'>Fence Name: " + fence.Name + "</div></div>";
                    });
                    var confirmMessage = "<div class='flex-container'> <div>The specified geofence overlaps with the following existing geofence(s): </div></div>" + intersectFences + "<div class='flex-container'><div>Continue?</div>";
                    RCNGWindow.ConfirmWindow.showConfirmBox(confirmMessage, self.onOKSubmit.bind(this, currentMode, latlonArray, currentFence, GeofencesData, true), self.closeConfirmation.bind(this, currentMode, currentFence, GeofencesData));
                    $("#confirmPopUpModel .btn-close").click(function () {
                        if (!IsTriggered) {
                            ReeferCallout.CancelDrawing();
                            if (currentMode == 'edit' && currentFence != null)
                                ReeferCallout.BindGeofencePolygons(GeofencesData);
                        }
                    });
                }
                else
                    self.onOKSubmit(currentMode, latlonArray, currentFence, GeofencesData, false);

                $("#globalLoader").hide();
            });
    }

    closeConfirmation(currentMode: string, currentFence: any, GeofencesData: any[]) {
        RCNGWindow.ConfirmWindow.close();
        ReeferCallout.CancelDrawing();
        if (currentMode == 'edit' && currentFence != null)
            ReeferCallout.BindGeofencePolygons(GeofencesData);
    }



    onOKSubmit(currentMode: string, coordinates: any, currentFence: any, GeofencesData: any[], IsConfirmationOpened: boolean) {
        if (!IsTriggered) {
            IsTriggered = true;
            if (IsConfirmationOpened)
                RCNGWindow.ConfirmWindow.close();
            if (currentMode == 'edit' && currentFence != null)
                self.renderAddGeofencePopup('Edit Geofence', coordinates, currentFence, GeofencesData);
            else
                self.renderAddGeofencePopup('Add Geofence', coordinates, currentFence, GeofencesData);
        }
    }

    renderAddGeofencePopup(formName: string, coordinates: any, currentFence: any, GeofencesData: any[]) {
        self.props.renderAddGeofenceControl(formName, coordinates, currentFence, GeofencesData);
    }
        
    loadCustomerGeofences(IsDeleted: boolean) {
        if (!fencesLoaded) {
            $("#globalLoader").show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeofenceCoordinates', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.GetGeofenceCoordinates[]>)
                .then(geofenceList => {
                    geofenceList.forEach(function (fence) {
                        var coordinatesList = [];
                        if (fence.Coordinates.length > 0) {
                            fence.Coordinates.forEach(function (point) {
                                var coordinates = new Microsoft.Maps.Location(point.Latitude, point.Longitude);
                                coordinatesList.push(coordinates);
                            });
                        }
                        fence.FormatedCoordinates = coordinatesList;
                    });
                    ReeferCallout.BindGeofencePolygons(geofenceList);
                    if (IsDeleted)
                        ReeferCallout.EraseMode();
                    $("#globalLoader").hide();
                });
        }
    }

    static ValidatePolygonGeofenceDashboard(coords: any, currentMode: any, currentFence: any, GeofencesData: any) {
        var coordinates: any = [];
        for (var i = 0; i < coords.length; i++) {
            var lat_long = coords[i].latitude + " " + coords[i].longitude;
            coordinates.push(lat_long);
        }
        var polygon: any = coordinates.join(","); 
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/ValidateGeofencePolygon', { method: 'POST', body: JSON.stringify((polygon)), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if(data) {
                    var isPolygon = ReeferCallout.pointInPolygon(coords);
                    if (isPolygon)   
                        this.bindGeofencePopupDashboard(currentMode, coords, currentFence, GeofencesData);
                    else
                        PopupWindow.showErrorMessage("Alert", "A self-intersecting polygon cannot be used to define a geofence. Please change the polygon accordingly.");
                }
                else
                {
                    PopupWindow.showErrorMessage("Alert","A polygon is invalid or cannot contain duplicate coordinates. Please change the polygon accordingly.");
                    return;
                }                
            });        
    }

    static refreshDashBoardMap() {
        $("#globalLoader").show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/GetGeofenceCoordinates', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GetGeofenceCoordinates[]>)
            .then(geofenceList => {
                geofenceList.forEach(function (fence) {
                    var coordinatesList = [];
                    if (fence.Coordinates.length > 0) {
                        fence.Coordinates.forEach(function (point) {
                            var coordinates = new Microsoft.Maps.Location(point.Latitude, point.Longitude);
                            coordinatesList.push(coordinates);
                        });
                    }
                    fence.FormatedCoordinates = coordinatesList;
                });
                ReeferCallout.BindGeofencePolygons(geofenceList);
                $("#globalLoader").hide();
            }); 
    }

    static DeleteCustomerGeofence(currentFence: any, fenceLayer: any, selectedfence: any) {
        $("#globalLoader").show();
        var inputParams: server.GeofenceParams = { FenceTypeCd: '', FenceId: '', FenceName: '', Address: '', Coordinates: [], ActionTypeCd: '', GeofenceCustomerID: '' };
        inputParams.ActionTypeCd = "D";
        inputParams.GeofenceCustomerID = currentFence.GeofenceCustomerID;
        inputParams.FenceTypeCd = currentFence.GeofenceCategoryCd;

        var geofenceParams = JSON.stringify(inputParams);

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/GeofenceManagement/SaveGeoFence', { method: 'POST', body: geofenceParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<string>)
            .then(message => {
                if (message == "Geofence deleted successfully.") {
                    fencesLoaded = false;
                    fenceLayer.remove(selectedfence);
                    self.loadCustomerGeofences(true);
                }
                else {
                    $("#globalLoader").hide();
                    PopupWindow.showErrorMessage("Alert", message);
                }
            });
    }

    drawingModePolygon(element: any) {
        ReeferCallout.SetDrawingMode('polygon', element);
    }
    drawingModeEdit(element: any) {
        ReeferCallout.SetDrawingMode('edit', element);
    }
    drawingModeDelete(element: any) {
        ReeferCallout.SetDrawingMode('erase', element);
    }

    showDrawingManagerTools() {
        this.loadCustomerGeofences(false);
        ReeferCallout.InitializeDrawingManager();
        this.setState({ buttonState: false });
        if (UserRights.checkVisibility('161') == 'show') $("#DrawingModes").show();
        fencesLoaded = true;
        self.setState({ IsLocationEstimated: false });
    }

    showGeoZonesLayer() {
        this.setState({ geoZonesEnabled: false });
        ReeferCallout.BindGeoZonesLayer();
    }

    closeDrawingManagerTools() {
        ReeferCallout.DisposeDrawingManager();
        this.setState({ buttonState: true });
        $("#DrawingModes").hide();
        $("#AddGeofenceMode").hide();
        $("#EditGeofenceMode").hide();
        $("#DeleteGeofenceMode").hide();
        fencesLoaded = false;
        self.setState({ IsLocationEstimated: false });
    }
    
    hideGeoZonesLayer() {
        this.setState({ geoZonesEnabled: true });
        ReeferCallout.DisposeGeozonesLayer();
    }
    
    static RestoreGeoZonesLayer() {
        self.setState({ geoZonesEnabled: true });
    }
    downloadPTReport() {
        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
            var blob = new Blob([self.state.PTIReport], {
                type: "text/plain;charset=utf-8"
            });
            window.navigator.msSaveBlob(blob, 'PT_' + self.state.ReportReeferId + '.htm');
        } else {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(self.state.PTReport));
            element.setAttribute('download', 'PT_' + self.state.ReportReeferId + '.htm');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }

    printPTReport() {
        var divToPrint = document.getElementById("printData");
        var newWin = window.open("");
        newWin.document.write(divToPrint.innerHTML);
        newWin.document.close();
        newWin.print();
        newWin.close();
    }

    static popUpGetPTIReport(selectedPin) {
        if (selectedPin.ReeferID != null) {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetPTRReport?containerID=' + selectedPin.ReeferID;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    self.setState({ PTReport: result }, () => { self.props.getCommandPopupPTReport(self.state.PTReport); });
                    self.setState({ ReportReeferId: selectedPin.ReeferID }, () => { self.props.getCommandPopupReportReeferId(self.state.ReportReeferId); });
                    $('#globalLoader').hide();
                    if (self.state.PTReport == null || self.state.PTReport == '')
                        PopupWindow.showErrorMessage("Alert", "No pre-trip reports have been collected for this reefer. Execute the ‘Get Pre-Trip Results’ command to collect the latest available report.");
                    else {
                        self.setState({ modelTitle: 'Pre-Trip Report', popUpHtmlReport: <div dangerouslySetInnerHTML={{ __html: self.state.PTReport }} /> }, () => { self.props.getCommandPopupTitleReport(self.state.modelTitle); self.props.getCommandPopupContentReport(self.state.popUpHtmlReport); });
                        $('#btnTriggerReport').click();
                    }
                });
        }

    }
}